<template>
  <v-card
    class="static-card pa-3"
    :style="`background-color: ${cardBackgroundColor}; color: ${cardTextColor};`"
    max-width="100%"
  >
    <div class="d-flex grow flex-wrap">
      <v-sheet
        v-if="headerIcon || headerText"
        :color="headerBackgroundColor"
        :max-height="headerIcon ? 90 : undefined"
        :width="headerIcon && !headerText ? 'auto' : '100%'"
        elevation="6"
        class="pa-7 mx-2 text-start static-card__heading mb-n6"
        dark
        rounded
      >
        <v-icon v-if="headerIcon" size="32" :color="headerColor">
          {{ $store.getters["app/icons"][headerIcon] }}
        </v-icon>

        <span
          v-if="headerText"
          class="headline font-weight-thin"
          v-text="headerText"
        />
      </v-sheet>

      <div 
        v-if="cardTitle"
        class="static-card__title"
      >
        {{ cardTitle }}
      </div>
    </div>    

    <slot />
  </v-card>
</template>
  
<script>
export default {
  name: "StaticCard",
  props: {
    cardTitle: {
      type: String,
      default: "",
    },
    cardBackgroundColor: {
      type: String,
      default: "white",
    },
    cardTextColor: {
      type: String,
      default: "black",
    },
    headerBackgroundColor: {
      type: String,
      default: "black",
    },
    headerColor: {
      type: String,
      default: "black",
    },
    headerIcon: {
      type: String,
      default: "",
    },
    headerText: {
      type: String,
      default: "",
    },
  },
};
</script>
  
<style lang="scss" scoped>
.static-card {
  width: 100%;
  max-width: 100%;
  background-color: white;
  position: relative;
  text-decoration: none;
  border-radius: 6px;
  padding: 0 12px 24px 12px;
  margin-bottom: 16px;
  width: 100%;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0),
    0 0 0 0 rgba(0, 0, 0, 0);
  overflow-wrap: break-word;
  position: relative;
  white-space: normal;
  outline: none;
  margin-top: calc(40px + 0px);

  .headline {
    margin-left: 16px;
  }

  &__title {
    flex: 1;
    margin-left: 16px;
    font-size: 20px;
  }

  &__heading {
    width: 100%;
    position: relative;
    top: -40px;
    transition: 0.3s ease;
    z-index: 1;
  }

  &__after-heading {
    flex: 1;
    margin-left: 16px;
  }

  &--hover-reveal:hover .static-card__heading {
    transform: translateY(-40px);
  }
}
</style>